import { IonButton, IonCol, IonContent, IonGrid, IonItem, IonLabel, IonList, IonPage, IonRadio, IonRadioGroup, IonRow } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { Redirect, useLocation } from "react-router-dom";
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import { translation } from "../../models/translation";
import { useExternalScript } from "../../services/load_external_script";
import { fetchPmtInitationData, upDatePaymentInfo } from "../../services/pmt_service";
import SwFundraiserPayComponent from "./SwFundraiserPaymentComponent";


const SwFundraiserCreditPay: React.FC = () => {

    const siteText = translation();

    const location = useLocation();

    const pmtNotes = [{
        key: 'finance_C',
        notes: siteText.donateDirectlyPayFeeTxt + '1.7% ',
        id: 97627,
        fee: 0.017
    },
    {
        key: 'finance_E',
        notes: siteText.donateDirectlyPayFeeTxt + '1.7% ',
        id: 97628,
        fee: 0.017
    },
    {
        key: 'creditcard',
        notes: siteText.donateDirectlyPayFeeTxt + '1.55%',
        id: 103396,
        fee: 0.0155
    },

    {
        key: 'twint',
        notes: siteText.donateDirectlyPayFeeTxt + '1.3%',
        id: 99165,
        fee: 0.013
    },
    {
        key: 'invoice',
        notes: siteText.donateDirectlyPayFeeTxt + '0',
        id: 103397,
        fee: 0.0
    }
    ]

    const info: any = location.state;

    const [amount] = useState<number>(() => {
        if (info) {
            return info.amount
        } else {
            return null
        }
    });
    const defalutCommission = 0.01;
    const transactionType = "donation";
    const [iframeUrl, setIframeUrl] = useState();
    const [paymentMethods, setPaymentMethods] = useState<any>();
    const [chosenMethod, setChosenMethod] = useState<any>();
    const [transactionId, setTransactionId] = useState<any>();
    const [version, setVersion] = useState<any>();
    const [chosenMethodName, setChosenMethodName] = useState<any>();
    const [contribution] = useState<any>(0);
    const [reloading, setRelaoding] = useState<boolean>(false);
    const [totalAmount, setTotalAmount] = useState<any>(() => {
        if (info) {
            return (info.amount) + (info.amount * defalutCommission)
        } else {
            return null
        }
    });

    const [fee, setFee] = useState<any>(0);


    //wait for component ready
    useEffect(() => {
        if (info && totalAmount) {
            fetchPmtInitationData(info.user, totalAmount, transactionType,'').then(tools => {
                if (!tools.error) {
                    let { jsUrl, pmtMtds, transactId, version } = tools.message
                    setIframeUrl(jsUrl);
                    setPaymentMethods(pmtMtds);
                    setTransactionId(transactId);
                    setVersion(version);
                }

            })
        }
    }, [])

    useEffect(() => {
        if (info) {
            updateTotalAmount();
        }
    }, [contribution, fee, amount]);


    useEffect(() => {
        if (transactionId) {
            setRelaoding(true);
            upDatePaymentInfo(info.user, totalAmount, transactionType, transactionId, version).then(
                m => {
                    if (!m.error) {
                        let { version } = m.message;
                        resetReloading(version);
                    }
                    return m;
                }
            )
        }

    }, [totalAmount])


    const resetReloading = (version: any) => {
        setVersion(version);
        setRelaoding(false)
    }
    /**
     * Return the current state of the payment method script that is loaded external
     */
    const state = useExternalScript(iframeUrl);

    /**
    * Choose amout text to show depending on the users current action
    * Checks the type prop value of the component
    * @returns amount text component
    */
    const AmountText = () => {
        return (
            <>{siteText.donateDirectlyPayTitle.replace('%%amount%%', '' + amount)}</>
        )
    }

    /**
     * Find the corresponding note for the current payment method in payment notes
     * @input :name  of the payment method
     * @returns: first corresponding method by name in payments notes

    */
    const getNotes = (id: number) => {
        let noteList = pmtNotes.filter((e, i, arr) => {
            if (e.id !== id) return
            return pmtNotes[i]
        })
        if (noteList.length > 0) {
            return noteList[0].notes
        } else {
            return '';
        }
    }

    /**
     * Find the corresponding note for the current payment method in payment notes
     * @input :name  of the payment method
     * @returns: first corresponding method by name in payments notes

    */
    const getFee = (id: number) => {
        let noteList = pmtNotes.filter((e, i, arr) => {
            if (e.id !== id) return
            return pmtNotes[i]
        })
        if (noteList.length > 0) {
            return noteList[0].fee
        } else {
            return '';
        }
    }



    const updateTotalAmount = () => {
        setTotalAmount((+info.amount + (info.amount * 0.01 * contribution) + (info.amount * fee)).toFixed(2))
    }

    const updateMethod = ({ value }: any) => {
        setChosenMethod(value.id);
        setFee(value.fee);
        setChosenMethodName(value.name);
    }



    return (
        <>{info ?
            <IonPage>
                <Header></Header>
                <IonContent>
                    <IonGrid className="sw-mt_sm sw_mb_sm">
                        <IonRow className="ion-justify-content-center ion-align-items-center'">
                            <IonCol sizeSm='11' sizeMd="10">
                                <IonRow>
                                    <IonCol>
                                        <h1><AmountText /></h1>
                                        <p>{siteText.SwFundraiserdonateDirectlyPayTotal.replace('%%amount%%', totalAmount)}</p>
                                        <h3>{siteText.donateDirectlyPayMethodSelect}</h3>
                                        <p> {siteText.donateDirectlyPayFeeNotice}
                                        </p>
                                    </IonCol>
                                </IonRow>

                                <IonRow>
                                    <IonCol sizeMd="8" >
                                        <IonList>
                                            <IonRadioGroup onIonChange={e => { updateMethod(e.detail) }}>
                                                {paymentMethods && paymentMethods.map((method: any, key: any) => {
                                                    if (method.id === 103397) {
                                                        return ("")
                                                    } else {
                                                        return (
                                                            <IonItem key={key}>
                                                                <IonLabel className="ion-text-wrap">{method.name}
                                                                    <br></br>
                                                                    <span className="pmt_notes">
                                                                        {getNotes(method.id)}
                                                                    </span>
                                                                </IonLabel>
                                                                <IonRadio value={{ id: method.id, fee: getFee(method.id), name: method.name }} disabled={reloading} />
                                                            </IonItem>
                                                        )
                                                    }
                                                })}

                                            </IonRadioGroup>
                                        </IonList>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol>
                                        <ul id="payment-errors"></ul>
                                        <div id="payment-form"></div>

                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol>
                                        <div>
                                            {state === "loading" && <p>Loading...</p>}
                                            {(state === "ready" && chosenMethod) ? <SwFundraiserPayComponent siteText={siteText} totalAmount={totalAmount} user={info.user} amount={amount} method={chosenMethodName} commition={info.amount * defalutCommission} type={transactionType} reloading={reloading} pmtMethod={chosenMethod} transactionId={transactionId} version={version} /> : <></>}
                                            {(state !== "ready" || !chosenMethod) ? <IonButton disabled={true}>{siteText.donateDirectlypayPrimary}</IonButton> : ''}
                                        </div>
                                    </IonCol>
                                </IonRow>
                            </IonCol>
                        </IonRow>

                    </IonGrid>
                    <Footer></Footer>
                </IonContent>
            </IonPage>
            : <Redirect to={siteText.lan + "/support_us"}></Redirect>}
        </>
    )
}


export default SwFundraiserCreditPay;